import React from 'react';
import { useIntl } from 'react-intl';

import { Select } from '@xsolla/ui-core';

type Props = {
  onChange: (value: string) => void;
  value: string;
};

enum SearchBySelectTypes {
  contact = 'contact',
  phone = 'phone',
  id = 'id',
  socialId = 'social-id',
  username = 'username',
  nickname = 'nickname',
  customId = 'custom_id'
}

export const SelectSearchBy = ({ onChange, value }: Props): JSX.Element => {
  const intl = useIntl();

  const selections = [
    {
      children: intl.messages['users.list-block.select-search-by.email'],
      value: SearchBySelectTypes.contact,
      'data-test-id': `search-contact-item`
    },
    {
      children: intl.messages['users.list-block.select-search-by.phone'],
      value: SearchBySelectTypes.phone,
      'data-test-id': `search-phone-item`
    },
    {
      children: intl.messages['users.list-block.select-search-by.id'],
      value: SearchBySelectTypes.id,
      'data-test-id': `search-id-item`
    },
    {
      children: intl.messages['users.list-block.select-search-by.socialId'],
      value: SearchBySelectTypes.socialId,
      'data-test-id': `search-social-id-item`
    },
    {
      children: intl.messages['users.list-block.select-search-by.username'],
      value: SearchBySelectTypes.username,
      'data-test-id': `search-username-item`
    },
    {
      children: intl.messages['users.list-block.select-search-by.nickname'],
      value: SearchBySelectTypes.nickname,
      'data-test-id': `search-nickname-item`
    },
    {
      children: intl.messages['users.list-block.select-search-by.customId'],
      value: SearchBySelectTypes.customId,
      'data-test-id': `search-customId-item`
    }
  ];

  return (
    <>
      <Select
        options={selections}
        placeholder={intl.formatMessage({
          id: 'users.list-block.select-search-by'
        })}
        value={value}
        onChange={onChange}
        size="sm"
        data-test-id="select-search-by"
      />
    </>
  );
};
